module.exports = __webpack_public_path__ + "static/img/head.f38649e0.png";